/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Title/view.blocks to change it.
import * as fromData from 'Simple/Data'
import DataVaxiomPersonTitleSelect from 'DesignSystem/Data/DataVaxiom/DataVaxiomPerson/DataVaxiomPersonTitleSelect/index'
import React from 'react'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function Title({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Main/Details/Title",
  onChange
  
}) {
  let isMedia = useIsMedia()
let profilePatientPersonTitleValueData = fromData.useDataValue({ viewPath,
context: 'profile_patient',
path: 'person.title',
})
let profilePatientPersonTitleChangeData = fromData.useDataChange({ viewPath,
context: 'profile_patient',
path: 'person.title',
})
  return (<React.Fragment
>
<DataVaxiomPersonTitleSelect
  viewPath={`${viewPath}/DataVaxiomPersonTitleSelect`}
 tabIndex={1}
 marginTop={0}
 size={isMedia.mobile ? "small" : "medium"}
 data="profile_patient.person.title"
 value={profilePatientPersonTitleValueData}
 onChange={profilePatientPersonTitleChangeData}
/>
{children}
</React.Fragment>)
}